// extracted by mini-css-extract-plugin
export default {"root":"Badge_root__5x1dv","sm":"Badge_sm__dYG2B","primary":"Badge_primary__r76yy","secondary":"Badge_secondary__Xm4GD"};